export default __webpack_public_path__ + "static/media/web.f1ac7f8f.gif";